import React from 'react';
import { useSelector } from 'react-redux';
import { Link, Switch, useRouteMatch } from 'react-router-dom';

import EditProfile from './EditProfile';
import ChangePassword from './ChangePassword';
import AuthorizedRoute from '../../../_helpers/authorized.route';
import ContainerFluid from '../../../_layouts/ContainerFluid';

export default function UserSettings({ history }) {
  let { path } = useRouteMatch();
  const currentUser = useSelector(state => state.user.currentUser)

  function isActive(path) {
    return history.location.pathname === path ? "active" : "";
  }

  return <ContainerFluid>
    <div className="row">
      <nav id="sidebarMenu" className="col-2 offset-1 d-sm-block nav flex-column nav-pills" style={{ top: '1.5em', padding: 0, backgroundColor: 'unset' }}>
        <ul className="nav flex-column">
          <li className="nav-item mb-2">
            <Link to="/settings/user/profile" className={`nav-link ${isActive(`${path}/profile`)}`}>
              <i className="far fa-address-card fa-fw" aria-hidden="true"></i>&nbsp;Edit Your Profile
            </Link>
          </li>
          <li className="nav-item mb-2">
            <Link to="/settings/user/change-password" className={`nav-link ${isActive(`${path}/change-password`)}`}>
              <i className="fa fa-unlock-alt fa-fw" aria-hidden="true"></i>&nbsp;Change Your Password
            </Link>
          </li>
        </ul>
      </nav>

      <main role="main" className="col-9 mr-auto px-3">
        <Switch>
          <AuthorizedRoute path={`${path}/profile`} component={EditProfile} />
          <AuthorizedRoute path={`${path}/change-password`} component={ChangePassword} />
        </Switch>
      </main>
    </div>
  </ContainerFluid>
}